<template>
    <div>
        <v-dialog v-model="sessionDialog" max-width="768">
            <v-card>
                <v-card-title>
                    <span>{{ $t('create_session') }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="webinarSessionForm">
                        <v-row>
                            <v-col cols="12" lg="12">
                                <v-text-field v-model="editedSessionItem.name" :label="$t('name')" required
                                    :rules="nameRules"></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="12">
                                <v-select v-model="editedSessionItem.driver" :items="drivers" :label="$t('driver')"
                                    item-text="title" item-value="driver" required>
                                </v-select>
                            </v-col>
                            <v-col cols="4" lg="4">
                                <v-text-field v-model="editedSessionItem.duration" :label="$t('duration')" required dense
                                    type="number">
                                    {{ $t('duration') }}</v-text-field>
                            </v-col>
                            <v-col cols="8" lg="8">

                                <v-slider v-model="editedSessionItem.duration" required min="0" max="2000"
                                    thumb-label="always" dense>

                                </v-slider>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="saveNewSession">
                        {{ $t('save') }}
                    </v-btn>
                    <v-btn color="primary" text @click="close">
                        {{ $t('close') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card>
            <v-data-table :headers="tableHeaders" :items="roomsList" :loading="loading" class="elevation-1"
                :server-items-length="totalRows" :options.sync="options" disable-sort item-key="id">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>{{ webinarName }}</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="getRoomsList">
                                    <v-icon large>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t('refresh') }}
                            </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="showFilter = !showFilter">
                                    <v-icon medium>mdi-filter</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t("filter") }}
                            </span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                    @click="sessionDialog = true" v-show="hasPermission('webinar_plus_room_add')">
                                    <v-icon large>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>
                                {{ $t('create_session') }}
                            </span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-expand-transition>
                        <v-sheet class="ma-3 pa-3" v-show="showFilter" dense>
                            <v-row dense flex>
                                <v-col cols="12" lg="2" md="4">
                                    <v-text-field v-model="nameFilter" @keydown.enter="getRoomsList()" :label="$t('name')"
                                        outlined dense hide-details>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" lg="1" md="4">
                                    <v-btn rounded @click="getRoomsList" color="primary">
                                        <v-icon> mdi-filter </v-icon>
                                        {{ $t("filter") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-expand-transition>
                </template>
                <template v-slot:[`item.driver`]="{ item }">
                    {{ $t(item.driver.toLowerCase()) }}
                </template>
                <template v-slot:[`item.users`]="{ item }"  >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on" v-show="item.driver=='BBB'">
                                <v-icon larg @click="showUsersDialog(item)">mdi-account-multiple</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('users') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.md_code`]="{ item }">
                    {{ item.md_code }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on">
                                <v-icon medium @click="joinTo(item.md_code)">mdi-account-star</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('join_as_moderator') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.at_code`]="{ item }">
                    {{ item.at_code }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on">
                                <v-icon medium @click="joinTo(item.at_code)">mdi-account</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('join_as_attendee') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.edit`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on"
                                :disabled="!hasPermission('webinar_plus_room_update')">
                                <v-icon medium @click="editItem(item)">mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('edit_session') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.sms`]="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on"
                                :disabled="!hasPermission('webinar_plus_room_link_sms')">
                                <v-icon medium @click="sendRoomInfoSMS(item)">mdi-message-processing</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('webinar_plus_room_link_sms') }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.records`]="{ item }"  >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="primary" v-bind="attrs" v-on="on" v-show="item.driver=='BBB'"
                                :disabled="!hasPermission('webinar_plus_room_records')">
                                <v-icon larg @click="showRecordsDialog(item)">mdi-record-rec</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('webinar_plus_room_records') }}</span>
                    </v-tooltip>
                </template> 
            </v-data-table>
        </v-card>
        <v-dialog v-model='recordsDialog' :key="room.id" scrollable>
            <WebinarRoomRecords :room="room" @close="closeRecordsDialog" />
        </v-dialog>
        <v-dialog v-model='usersDialog'  scrollable width="700">
            <SessionUsers :key="room.id" :roomId="room.id" @close="closeUsersDialog"></SessionUsers>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
import SessionUsers from './SessionUsers.vue';
import WebinarRoomRecords from './WebinarRoomRecords.vue';
import permissions from '../mixins/permissions';
export default {
    name: "WebinarRooms",
    components: { SessionUsers },
    mixins: [permissions],
    props: ["company", "webinarName"],
    data() {
        return {
            tableHeaders: [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("duration"), value: "duration" },
                { text: this.$t("driver"), value: "driver" },
                { text: this.$t("users"), value: "users"  },
                { text: this.$t("md_code"), value: "md_code" },
                { text: this.$t("at_code"), value: "at_code" },
                { text: this.$t("edit"), value: "edit" },
                { text: this.$t("sms"), value: "sms" },
                { text: this.$t("records"), value: "records" },
            ],
            roomsList: [],
            sessionDialog: false,
            showFilter: false,
            nameFilter: '',
            defaultSessionItem: { id: null, name: '', driver: 'bigblubutton', duration: 30 },
            editedSessionItem: { id: null, name: '', driver: null, duration: 30 },
            nameRules: [v => !!v || this.$t("name_required")],
            drivers: [
                {
                    title: this.$t('bigbluebutton'),
                    driver: 'BBB',
                },
                {
                    title: this.$t('skyroom'),
                    driver: 'SR',
                },
                {
                    title: this.$t('adobeconnect'),
                    driver: 'AD',
                },
            ],
            editedIndex: -1,
            itemPerPage: 10,
            pageNumber: 1,
            plans: [],
            loading: false,
            options: {},
            totalRows: 0,
            startRow: 0,
            endRow: 10,
            frontendUrl: '',
            recordsDialog: false,
            room:{},
            usersDialog:false,
        };
    },
    watch: {
        options: {
            handler() {
                this.getRoomsList();
            },
            deep: true,
        }
    },
    methods: {
        getRoomsList() {
            const { page, itemsPerPage } = this.options;
            const payload = { page:page, itemsPerPage:itemsPerPage};
            if (this.nameFilter != '') {
                payload['name'] = this.nameFilter;
            }
            this.loading = true;
            if (this.company) {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.company + "/rooms",
                    method: "GET",
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        Authorization: this.$store.get("login/token"),
                    },
                    params: payload
                }).then(response => {
                    console.log("data", response);
                    const data = response.data;
                    this.roomsList = data.data;
                    this.totalRows = data.totalRows;
                    this.loading = false;
                });
            }
        },
        joinTo(code) {
            window.open(this.frontendUrl + "/join/" + code, "_blank");
        },
        validateWebinarSessionForm() {
            this.$refs.webinarSessionForm.validate();
        },
        resetValidateWebinarSessionForm() {
            // this.$refs.webinarForm.resetValidation();
        },
        close() {
            this.sessionDialog = false;
            this.$nextTick(() => {
                this.editedSessionItem = Object.assign({}, this.defaultSessionItem);
                this.editedIndex = -1;
                this.resetValidateWebinarSessionForm();
            });
        },
        editItem(item) {
            this.editedIndex = this.roomsList.indexOf(item);
            this.editedSessionItem = Object.assign({}, item);
            this.sessionDialog = true;
        },
        saveNewSession() {
            if (!this.$refs.webinarSessionForm.validate()) {
                this.$toasted.error(this.$t("fill_the_form"), { icon: { name: "alert-circle" } });
            }
            else {


                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/companies/" + this.company + "/rooms",
                    method: this.editedSessionItem.id != null ? "PUT" : "POST",
                    headers: {
                        Authorization: this.$store.get("login/token"),
                    },
                    data: this.editedSessionItem,
                }).then(response => {
                    console.log(response.data);
                    this.close();
                    this.getRoomsList();
                    this.$toasted.success(this.$t("webinar_session_added_successfully"));
                }).catch(error => {
                    console.log(error.response);
                    this.$toasted.error(this.$t("webinar_session_error_saving"));
                });
            }
        },
        sendRoomInfoSMS(item) {
            let payload = { room_id: item.id };
            axios({
                url: process.env.VUE_APP_BACKEND_URL + `/api/webinar_plus/companies/${item.company_id}/rooms/${item.id}/sms`,
                method: "GET",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: payload
            }).then(response => {
                console.log(response.data);
                this.$toasted.success(this.$t("send_room_info_sms_successfully"));
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("send_room_info_sms_error"));
            })
        },
        getFrontendUrl() {
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/config/webinar_plus/frontend_url",
                method: "GET",
                contentType: "",
                headers: {
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                this.frontendUrl = response.data.value;
            }).catch(error => {
                console.log(error.response);

            });
        },
        showRecordsDialog(item) {
            this.room = Object.assign({}, item);
            this.recordsDialog = true;
        },
        showUsersDialog(item) {
            this.room = Object.assign({}, item);
            this.usersDialog = true;
        },
        closeRecordsDialog() {
            this.room = {};
            this.recordsDialog = false;
        },
        closeUsersDialog() {
            this.room = {};
            this.usersDialog = false;
        },
    },
    mounted() {
        this.getRoomsList();
        this.getFrontendUrl()
    }
}
</script>